/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MediaBlockData } from './MediaBlockData'
import {
  MediaBlockDataFromJSON,
  MediaBlockDataFromJSONTyped,
  MediaBlockDataToJSON,
} from './MediaBlockData'

/**
 *
 * @export
 * @interface MediaBlock
 */
export interface MediaBlock {
  /**
   *
   * @type {string}
   * @memberof MediaBlock
   */
  type: MediaBlockTypeEnum
  /**
   *
   * @type {MediaBlockData}
   * @memberof MediaBlock
   */
  data: MediaBlockData
}

/**
 * @export
 * @enum {string}
 */
export enum MediaBlockTypeEnum {
  MediaBlock = 'media_block',
}

/**
 * Check if a given object implements the MediaBlock interface.
 */
export function instanceOfMediaBlock(value: object): value is MediaBlock {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function MediaBlockFromJSON(json: any): MediaBlock {
  return MediaBlockFromJSONTyped(json, false)
}

export function MediaBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MediaBlock {
  if (json == null) {
    return json
  }
  return {
    type: json['type'],
    data: MediaBlockDataFromJSON(json['data']),
  }
}

export function MediaBlockToJSON(value?: MediaBlock | null): any {
  if (value == null) {
    return value
  }
  return {
    type: value['type'],
    data: MediaBlockDataToJSON(value['data']),
  }
}
